import React from 'react';
import Banner_Video from '../assets/Banner_Video.mp4';
import About from '../components/About';
import { useNavigate } from 'react-router-dom';


const HomePage = () => {
  const navigate = useNavigate();

  const exploreServices = () => {
    console.log("Hi")
    navigate('/services');
  }

  return (
    <div className="relative">
      {/* Hero Section with Video Background */}
      <div className="relative h-screen w-full overflow-hidden">
        {/* Video Background */}
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover opacity-50 z-0 blur-sm"
        >
          <source src={Banner_Video} type="video/mp4" />
        </video>

        {/* Text Overlay */}
        <div className="absolute inset-0 flex items-center justify-start z-10 px-8 lg:px-16">
          <div className="max-w-2xl w-full space-y-8 text-left mx-12">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight drop-shadow-xl">
              Data & Analytics Consultancy Ireland
            </h1>
            
            <p className="text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-8 drop-shadow-md">
              We help firms increase market share, revenue, and efficiency through 
              <span className="text-blue-400"> Artificial Intelligence</span>, 
              <span className="text-green-400"> Data</span> and 
              <span className="text-purple-400"> Analytics</span>.
            </p>

            <button 
              onClick={() => exploreServices()}
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg 
                       text-xl font-semibold transition-all duration-300 transform
                       hover:scale-105 shadow-lg"
            >
              Explore Services →
            </button>
          </div>
        </div>
      </div>

      {/* About Section (or any other content) */}
      <About />
    </div>
  );
};

export default HomePage;